<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-star mr-2" />Role</h5>
            <hr />
            <b-row class="d-flex justify-content-between ml-1">
                <b-col md="3" class="p-0">
                    <b-form-group label="Nama Role">
                        <b-input-group>
                            <b-form-input v-model="filter.name" @keydown.enter="getItems" placeholder="Masukkan nama role" />
                            <b-input-group-append>
                                <b-button variant="primary" @click="getItems()">
                                <i class="fa fa-search mr-2" />Cari
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col md="3" class="text-right">
                    <b-form-group label="Tambah">
                        <b-button variant="success" @click="prepareAdd">
                            <i class="fa fa-plus mr-2" />Role Baru
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                @sort-changed="onSortChanged"
                responsive 
            >
                <template v-slot:empty>
                    Tidak ada data role.
                </template>
                <template v-slot:cell(access)="row">
                    {{ row.item.permissionIds.length }} akses menu
                </template>
                <template v-slot:cell(action)="row">
                    <b-button size="sm" variant="warning" v-b-tooltip.hover.top title="Edit" @click="prepareEdit(row.item)">
                        <i class="fa fa-fw fa-pencil" />
                    </b-button>
                </template>
            </b-table>
            <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" @page-change="onPageChange" />
        </b-card>
        <b-modal id="m-create" title="Tambah Role Baru" no-close-on-backdrop no-close-on-esc hide-footer size="xl" dialog-class="modal-permission-width">
            <b-form-group label="Nama Role">
                <b-input v-model="input.name" maxlength="100" />
            </b-form-group>
            <b-form-group label="Akses yang Diberikan">
                <div class="mb-3 pb-3 border-bottom">
                    <b-form-checkbox @change="selectAllPermissions" v-model="selectAll">
                        <span class="font-weight-bold">Berikan Semua Akses</span>
                    </b-form-checkbox>
                </div>
                <div v-if="permissionsWithChildren.length > 0" class="mb-4">
                    <b-row>
                        <b-col v-for="(permit, index) in permissionsWithChildren" :key="'permit-with-child-'+index" md="3" sm="6" class="mb-3">
                            <div class="permission-card bg-light p-0 border rounded d-flex flex-column" style="max-height: 300px;">
                                <div class="permission-header text-white p-2 rounded-top" style="background-color: #11469a;">
                                    <b-form-checkbox @change="selectCheckboxParent(permit, permit.originalIndex)" v-model="permit.checked" class="mb-0 permission-header-checkbox">
                                        <span class="font-weight-bold text-uppercase">{{permit.text}}</span>
                                    </b-form-checkbox>
                                </div>
                                <div class="permission-children p-3 mt-0" style="max-height: 240px; overflow-y: scroll !important;">
                                    <b-form-checkbox v-for="(permitChild, index2) in permit.child" :key="'permit-child-'+index2" v-model="permitChild.checked" @change="selectCheckboxChild(permitChild, permit.originalIndex, index2)" class="d-block mb-1">
                                        {{permitChild.text}}
                                    </b-form-checkbox>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <div v-if="permissionsWithoutChildren.length > 0">
                    <b-row>
                        <b-col v-for="(permit, index) in permissionsWithoutChildren" :key="'permit-no-child-'+index" md="3" sm="6" class="mb-3">
                            <div class="permission-card bg-light p-0 border rounded d-flex flex-column">
                                <div class="permission-header text-white p-2 rounded-top" style="background-color: #11469a;">
                                    <b-form-checkbox @change="selectCheckboxParent(permit, permit.originalIndex)" v-model="permit.checked" class="mb-0 permission-header-checkbox">
                                        <span class="font-weight-bold text-uppercase">{{permit.text}}</span>
                                    </b-form-checkbox>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="confirmCreate">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-edit" title="Edit Role" no-close-on-backdrop no-close-on-esc hide-footer size="xl" dialog-class="modal-permission-width">
            Mengubah role <strong>{{ activeItem.name }}</strong>
            <b-form-group label="Nama Role">
                <b-input v-model="edit.name" maxlength="100" />
            </b-form-group>
            <b-form-group label="Akses yang Diberikan">
                <div class="mb-3 pb-3 border-bottom">
                    <b-form-checkbox @change="selectAllPermissions" v-model="selectAll">
                        <span class="font-weight-bold">Berikan Semua Akses</span>
                    </b-form-checkbox>
                </div>
                <div v-if="permissionsWithChildren.length > 0" class="mb-4">
                    <h6 class="mb-3 text-muted">Permission dengan Sub-Permission</h6>
                    <b-row>
                        <b-col v-for="(permit, index) in permissionsWithChildren" :key="'permit-with-child-'+index" md="3" sm="6" class="mb-3">
                            <div class="permission-card bg-light p-0 border rounded d-flex flex-column" style="max-height: 300px;">
                                <div class="permission-header text-white p-2 rounded-top" style="background-color: #11469a;">
                                    <b-form-checkbox @change="selectCheckboxParent(permit, permit.originalIndex)" v-model="permit.checked" class="mb-0 permission-header-checkbox">
                                        <span class="font-weight-bold text-uppercase">{{permit.text}}</span>
                                    </b-form-checkbox>
                                </div>
                                <div class="permission-children p-3 mt-0" style="max-height: 240px; overflow-y: scroll !important;">
                                    <b-form-checkbox v-for="(permitChild, index2) in permit.child" :key="'permit-child-'+index2" v-model="permitChild.checked" @change="selectCheckboxChild(permitChild, permit.originalIndex, index2)" class="d-block mb-1">
                                        {{permitChild.text}}
                                    </b-form-checkbox>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <div v-if="permissionsWithoutChildren.length > 0">
                    <h6 class="mb-3 text-muted">Permission Standalone</h6>
                    <b-row>
                        <b-col v-for="(permit, index) in permissionsWithoutChildren" :key="'permit-no-child-'+index" md="3" sm="6" class="mb-3">
                            <div class="permission-card bg-light p-0 border rounded d-flex flex-column">
                                <div class="permission-header text-white p-2 rounded-top" style="background-color: #11469a;">
                                    <b-form-checkbox @change="selectCheckboxParent(permit, permit.originalIndex)" v-model="permit.checked" class="mb-0 permission-header-checkbox">
                                        <span class="font-weight-bold text-uppercase">{{permit.text}}</span>
                                    </b-form-checkbox>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="confirmEdit">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            show: 10,

            filter: {
                name: ""
            },

            input: {
                name: "",
                permissions: []
            },

            edit: {
                name: "",
                permissions: []
            },

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "name", label: "Nama Role", sortable: true },
                { key: "access", label: "Akses", sortable: true },
                { key: "action", label: "Aksi" },
            ],

            items: [],
            activeItem: {
                id: null
            },
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            optPermission: [],

            selectAll: false

        }
    },

    computed: {
        groupedPermissions() {
            const withChildren = []
            const withoutChildren = []

            this.optPermission.forEach((permit) => {
                if (permit.child && permit.child.length > 0) {
                    withChildren.push(permit)
                } else {
                    withoutChildren.push(permit)
                }
            })

            return { withChildren, withoutChildren }
        },
        permissionsWithChildren() {
            return this.groupedPermissions.withChildren
        },
        permissionsWithoutChildren() {
            return this.groupedPermissions.withoutChildren
        }
    },

    methods: {

        selectCheckboxParent(data, index){
            if(data.checked == false){
                for(let i = 0; i < this.optPermission[index].child.length; i++){
                    this.optPermission[index].child[i].checked = true
                }
            } else {
                for(let i = 0; i < this.optPermission[index].child.length; i++){
                    this.optPermission[index].child[i].checked = false
                }
            }
            this.updateSelectAllState()
        },

        selectCheckboxChild(data, parentIndex, index){
            if(data.checked == false){
                this.optPermission[parentIndex].child[index].checked = true
                let checkedParent = true
                for(let i = 0; i < this.optPermission[parentIndex].child.length; i++){
                    if(!this.optPermission[parentIndex].child[i].checked){
                        checkedParent = false
                        break
                    }
                }
                this.optPermission[parentIndex].checked = checkedParent
            } else {
                this.optPermission[parentIndex].child[index].checked = false
                this.optPermission[parentIndex].checked = false
            }
            this.updateSelectAllState()
        },

        selectAllPermissions(checked) {
            for(let i = 0; i < this.optPermission.length; i++){
                this.optPermission[i].checked = checked
                if(this.optPermission[i].child && this.optPermission[i].child.length > 0){
                    for(let j = 0; j < this.optPermission[i].child.length; j++){
                        this.optPermission[i].child[j].checked = checked
                    }
                }
            }
        },

        updateSelectAllState() {
            let allChecked = true
            for(let i = 0; i < this.optPermission.length; i++){
                if(this.optPermission[i].child && this.optPermission[i].child.length > 0){
                    if(!this.optPermission[i].checked){
                        allChecked = false
                        break
                    }
                    for(let j = 0; j < this.optPermission[i].child.length; j++){
                        if(!this.optPermission[i].child[j].checked){
                            allChecked = false
                            break
                        }
                    }
                    if(!allChecked) break
                } else {
                    if(!this.optPermission[i].checked){
                        allChecked = false
                        break
                    }
                }
            }
            this.selectAll = allChecked
        },

        getPermissions(edit) {
            this.optPermission = []
            if(edit){
                this.$axios.get("permission/selection").then(res => {
                    for(let i = 0; i < res.data.data.length; i++){
                        let allChecked = true
                        let child = []
                        if(res.data.data[i].child.length > 0){
                            for(let j = 0; j < res.data.data[i].child.length; j++){
                                if(this.edit.permissions.includes(res.data.data[i].child[j].value)){
                                    child.push({
                                        value: res.data.data[i].child[j].value,
                                        text: res.data.data[i].child[j].text,
                                        checked: true
                                    })
                                } else {
                                    child.push({
                                        value: res.data.data[i].child[j].value,
                                        text: res.data.data[i].child[j].text,
                                        checked: false
                                    })
                                    allChecked = false
                                }
                            }
                            if(allChecked){
                                this.optPermission.push({
                                    value: res.data.data[i].value,
                                    text: res.data.data[i].text,
                                    child: child,
                                    checked: true,
                                    originalIndex: i
                                })
                            } else {
                                this.optPermission.push({
                                    value: res.data.data[i].value,
                                    text: res.data.data[i].text,
                                    child: child,
                                    checked: false,
                                    originalIndex: i
                                })
                            }
                        } else {
                            if(this.edit.permissions.includes(res.data.data[i].value)){
                                this.optPermission.push({
                                    value: res.data.data[i].value,
                                    text: res.data.data[i].text,
                                    child: [],
                                    checked: true,
                                    originalIndex: i
                                })
                            } else {
                                this.optPermission.push({
                                    value: res.data.data[i].value,
                                    text: res.data.data[i].text,
                                    child: [],
                                    checked: false,
                                    originalIndex: i
                                })
                            }
                        }
                    }
                    this.updateSelectAllState()
              })
            } else {
                this.$axios.get("permission/selection").then(res => {
                    this.optPermission = res.data.data.map((it, idx) => {
                        return { value: it.value, text: it.text, checked: false, originalIndex: idx, child: it.child.map(it2 => {
                            return { value: it2.value, text: it2.text, checked: false}
                        })}
                    })
                    this.selectAll = false
                })
            }
        },

        init() {

            this.initStatus = 0
            let getItems = this.getItems()

            Promise.all([getItems]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                this.initStatus = -1
            })

        },

        confirmCreate() {

            if(this.$helper.isBlank(this.input.name)) {
                return this.$helper.toastError(this, "Nama tidak boleh kosong!")
            }

            let isConfirmed = confirm("Simpan role baru ini?")
            if(!isConfirmed) return

            this.input.permissions = []

            for(let i = 0; i < this.optPermission.length; i++){
                if(this.optPermission[i].child.length > 0){
                    for(let j = 0; j < this.optPermission[i].child.length; j++){
                        if(this.optPermission[i].child[j].checked){
                            this.input.permissions.push(this.optPermission[i].child[j].value)
                        }
                    }
                } else {
                    if(this.optPermission[i].checked){
                        this.input.permissions.push(this.optPermission[i].value)
                    }
                }
            }

            let payload = {
                name: this.input.name,
                permissionIds: this.input.permissions
            }

            this.isSubmitting = true
            this.$axios.post("role", payload).then(res => {

                this.$helper.toastSuccess(this, "Role baru berhasil ditambahkan!")
                this.$bvModal.hide("m-create")
                this.input.name = ""
                this.input.permissions = []
                this.getItems(this.currentPage)

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        prepareAdd() {
            this.selectAll = false
            this.getPermissions(false)
            this.$bvModal.show('m-create')
        },

        prepareEdit(item) {
            this.activeItem = item
            this.edit.name = item.name
            this.edit.permissions = item.permissionIds
            this.selectAll = false
            this.getPermissions(true)
            this.$bvModal.show("m-edit")
        },

        confirmEdit() {

            if(this.$helper.isBlank(this.edit.name)) {
                return this.$helper.toastError(this, "Nama tidak boleh kosong!")
            }

            let isConfirmed = confirm("Simpan perubahan role ini?")
            if(!isConfirmed) return

            this.edit.permissions = []

            for(let i = 0; i < this.optPermission.length; i++){
                if(this.optPermission[i].child.length > 0){
                    for(let j = 0; j < this.optPermission[i].child.length; j++){
                        if(this.optPermission[i].child[j].checked){
                            this.edit.permissions.push(this.optPermission[i].child[j].value)
                        }
                    }
                } else {
                    if(this.optPermission[i].checked){
                        this.edit.permissions.push(this.optPermission[i].value)
                    }
                }
            }

            let payload = {
                name: this.edit.name,
                permissionIds: this.edit.permissions
            }

            this.isSubmitting = true
            this.$axios.post("role/" + this.activeItem.id, payload).then(res => {

                this.$helper.toastSuccess(this, "Role berhasil diubah!")
                this.$bvModal.hide("m-edit")
                this.getItems(this.currentPage)

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        getItems(page = 1) {

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)

            if(!this.$helper.isBlank(this.filter.name)) {
                param += "&name=" + this.filter.name
            }

            if(!this.$helper.isBlank(this.sortBy)) {
                param += "&sortBy=" + this.sortBy
                param += "&sortDesc=" + this.sortDesc
            }

            return this.$axios.get("role" + param).then(res => {
                this.items = res.data.data.items
                this.totalRows = res.data.data.total
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            this.getItems(this.currentPage)
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

    },

    created() {
        this.init()
    }
}
</script>

<style scoped>
.permission-card {
    transition: box-shadow 0.2s;
}

.permission-card:hover {
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.permission-children {
    scrollbar-width: auto !important;
    scrollbar-color: #495057 #e9ecef !important;
}

.permission-children::-webkit-scrollbar {
    width: 16px !important;
    display: block !important;
    -webkit-appearance: none !important;
}

.permission-children::-webkit-scrollbar-track {
    background: #e9ecef !important;
    border-left: 1px solid #dee2e6 !important;
}

.permission-children::-webkit-scrollbar-thumb {
    background-color: #495057 !important;
    border: 3px solid #e9ecef !important;
    border-radius: 8px !important;
}

.permission-children::-webkit-scrollbar-thumb:hover {
    background-color: #343a40 !important;
}

.permission-header-checkbox ::v-deep .custom-control-label {
    color: white !important;
}

.permission-header-checkbox ::v-deep .custom-control-input:checked ~ .custom-control-label::before {
    background-color: white;
    border-color: white;
}

.permission-header-checkbox ::v-deep .custom-control-input:checked ~ .custom-control-label::after {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23007bff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3e%3c/svg%3e");
}
</style>

<style>
.modal-permission-width {
    max-width: 1600px !important;
}

</style>
